import { NgxLoggerLevel } from 'ngx-logger';
import { APP_VERSION } from '../app-version';

/*
 * Backend-Host des Prod-Bundles.
 *
 * Dasselbe Prod-Bundle wird auf portal.salfeld.net UND auf dev.salfeld.net ausgeliefert. Ohne diese
 * Ableitung spraeche ein auf dev deployter Stand gegen die PRODUKTIV-API — also gegen echte
 * Kundendaten, waehrend auf dev getestet wird. Der Host wird deshalb einmalig beim Laden aus der
 * ausgelieferten Seite bestimmt.
 *
 * Bewusst KEIN generisches "immer dieselbe Origin": ein Bundle auf einem Host ohne eigenes Backend
 * (Staging, File-Share, lokal geoeffnet) muss weiterhin gegen portal laufen. Deshalb eine explizite
 * Ausnahme fuer dev und portal als Default.
 *
 * Hinweis fuers Backend: der ChicoAuthenticationFilter aktiviert Header-/Cookie-Auth nur, wenn die
 * Request-URL "portal" oder "dev.salfeld." enthaelt. Beide Hosts erfuellen das — ein dritter Host
 * wuerde die Session-Auth stillschweigend verlieren.
 */
const DEV_HOST = 'dev.salfeld.net';

const apiHost =
  (typeof window !== 'undefined' && window.location && window.location.hostname === DEV_HOST)
    ? `https://${DEV_HOST}`
    : 'https://portal.salfeld.net';

export const environment = {
  production: true,
  version: APP_VERSION.replace('0.0.', ''),
  apiUrl: `${apiHost}/api/`,
  apiFiles : `${apiHost}/files/`,
  // Statische Hilfe-Bilder bleiben bewusst auf portal: umgebungsunabhaengig und auf dev nicht zwingend vorhanden.
  imgScreenshotSetupDE: 'https://portal.salfeld.net/images/screenshot-prepare-de.jpg',
  imgScreenshotSetupEN: 'https://portal.salfeld.net/images/screenshot-prepare-en.jpg',
  logLevel: NgxLoggerLevel.ERROR,
  ga : 'UA-2412316-5'
};
